export const THIRD_PARTY_SOURCE_KIND = '5';

export interface ThirdPartyAccountExtraData {
  availableDays: number;
}

export interface ThirdPartyAccountData {
  id: string;
  account: string;
  accountName: string;
  description: string;
  createDt: string;
  updateDt: string;
  sourceKind: string;
  state: string;
  token?: string;
  extraData: ThirdPartyAccountExtraData;
}

// 列表用，index 為前端計算出來的顯示序號
export interface ThirdPartyAccountTableData extends ThirdPartyAccountData {
  index: number;
}

export interface SearchThirdPartyAccountRequest {
  pageNumber: number;
  pageSize: number;
  sourceKinds: Array<number>;
}

export interface SearchThirdPartyAccountResponse {
  content: Array<ThirdPartyAccountData>;
  pageable: {
    pageNumber: number;
    pageSize: number;
  };
  totalPages: number;
}

export interface GetThirdPartyAccountRequest {
  id: string;
}

export interface CreateThirdPartyAccountRequest {
  account: string;
  accountName: string;
  sourceKind: string;
  state: string;
  description: string;
  extraData: ThirdPartyAccountExtraData;
}

export interface UpdateThirdPartyAccountRequest {
  id: string;
  account: string;
  state: string;
  accountName: string;
  description: string;
  extraData: ThirdPartyAccountExtraData;
}

export interface RegenerateTokenRequest {
  account: string;
}

export interface RegenerateTokenResponse {
  token: string;
}

// 新增/編輯頁面的表單值
export interface ThirdPartyAccountFormValues {
  account: string;
  accountName: string;
  description: string;
  availableDays: string;
  searchLimitDays: string;
  searchStartDate: Date | null;
  searchEndDate: Date | null;
}

// 第三方廠商帳號與工廠的關聯 (POST/PUT/DELETE 共用)
export interface ThirdPartyAccountFactoryRequest {
  account: string;
  factory_ids: Array<number>;
}

// 後端 LocalDate 回傳格式為 [年, 月, 日] (月份從1開始)
export type ThirdPartyAccountSearchLimitDate = [number, number, number];

// 第三方廠商帳號的限制搜尋資料日期 (POST/PUT 的 request, 日期格式為 YYYY-MM-DD)
export interface ThirdPartyAccountSearchLimit {
  account: string;
  limit_request_date_to_now: number;
  limit_request_date_range_start: string | null;
  limit_request_date_range_end: string | null;
}

// 第三方廠商帳號的限制搜尋資料日期 (GET/POST/PUT 的 response)
export interface ThirdPartyAccountSearchLimitResponse {
  account: string;
  limit_request_date_to_now: number;
  limit_request_date_range_start: ThirdPartyAccountSearchLimitDate | null;
  limit_request_date_range_end: ThirdPartyAccountSearchLimitDate | null;
}

// /thirdparty 底下每支API回傳資料的單一物件全部欄位 (GET api-columns 的 response)
export interface ThirdPartyApiColumns {
  api_path: string;
  column_names: Array<string>;
}

// 第三方廠商帳號與API回傳資料欄位的關聯 (GET 的 response 及 POST/PUT/DELETE 的 request/response 共用)
export interface ThirdPartyAccountApiColumnRequest {
  account: string;
  api_path: string;
  column_names: Array<string>;
}
